<div
  [ngStyle]="{
    'max-width': block.imageContainerWidth ? block.imageContainerWidth + 'px' : 'none',
    'max-height': block.imageContainerHeight ? block.imageContainerHeight + 'px' : 'none',
    'min-width': block.imageContainerWidth ? block.imageContainerWidth + 'px' : 'none',
    'min-height': block.imageContainerHeight ? block.imageContainerHeight + 'px' : 'none',
  }">
  <img [src]="block | blockImageSrc" />
</div>
